class Cart {
  constructor() {
    this.formatter = new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD",
      maximumFractionDigits: 2,
    })
    this.starEnabled = false
  }

  // Common API methods
  async fetchAPI(api, formData) {
    const response = await fetch(`/cart/${api}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(formData),
    })
    return await response.json()
  }

  addItem(formData) {
    return this.fetchAPI("add.js", formData)
  }

  changeItem(formData) {
    return this.fetchAPI("change.js", formData)
  }

  async getItems() {
    const response = await fetch(`/cart.js`)
    return response.json()
  }

  async getProduct(handle) {
    const response = await fetch(`/products/${handle}.js`)
    return response.json()
  }

  // Common utility methods
  showInterval(num = 0) {
    const interval = {
      month_0: "",
      month_1: "Every Month",
      month_2: "Every 2 Months",
      month_3: "Every 3 Months",
      month_4: "Every 4 Months",
      month_5: "Every 5 Months",
      month_45: "Every 1.5 Months",
    }
    return interval[`month_${num}`]
  }

  showMonthlyPrice(freq, price) {
    return this.formatter.format(price / freq / 100) + "/month"
  }

  // Common change quantity method
  async changeQty(btn) {
    const action = btn.dataset.action
    const line = parseInt(btn.dataset.line)
    let qty = parseInt(btn.dataset.qty)

    if (action == "increase") {
      qty++
    } else {
      qty--
    }

    const formData = {
      line: line + 1,
      quantity: qty,
    }

    this.changeItem(formData).then(() => this.updateCart())
  }

  // Common change weight method with Optimistic UI
  async changeWeight(action, weight, line, handle) {
    // 1. Target the specific product row in the DOM (line is index + 1)
    const productRow = document.querySelectorAll('.ajax-cart__product')[line - 1];
    const inputField = productRow ? productRow.querySelector('input') : null;
    const buttons = productRow ? productRow.querySelectorAll('button') : [];

    // 2. Prevent race conditions: Disable buttons and visually indicate sync
    if (productRow) {
      buttons.forEach(btn => btn.style.pointerEvents = 'none');
      productRow.style.opacity = '0.5'; 
      productRow.style.transition = 'opacity 0.2s ease';
    }

    const selectedProduct = await this.getProduct(handle);

    let increment = 10;
    if (handle.includes('pelletized') || handle.includes('wood-pellets')) {
      increment = 20;
    }

    let newTitle = "";
    if (action == "increase") {
      newTitle = parseInt(weight) + increment + "lbs"
    } else {
      newTitle = parseInt(weight) - increment + "lbs"
    }

    if (weight.includes("one-time-purchase")) {
      newTitle += " one-time-purchase"
    }

    // 3. Optimistic UI Update: Change the input value instantly
    if (inputField) {
      inputField.value = newTitle;
    }

    const variants = selectedProduct.variants
    let variantIndex = variants.findIndex(({ title }) => title == newTitle)
    
    // Failsafe: if they hit max/min weight, revert the UI and exit
    if (variantIndex === -1) {
      if (inputField) inputField.value = weight; // revert text
      if (productRow) {
        buttons.forEach(btn => btn.style.pointerEvents = 'auto');
        productRow.style.opacity = '1';
      }
      return;
    }

    let variantId = variants[variantIndex].id

    const formData = {
      items: [
        {
          id: variantId,
          quantity: 1,
        },
      ],
    }

    // 4. Perform the background API sync sequentially
    try {
      await this.changeItem({ line: line, quantity: 0 });
      await this.addItem(formData);
      await this.updateCart(); // This automatically removes the opacity and re-enables buttons upon fresh render
    } catch (error) {
      console.error("Cart sync failed:", error);
      // Failsafe render to ensure cart UI matches actual backend state if an error occurs
      await this.updateCart(); 
    }
  }

  // Common edit subscription method
  editSubscription(weight, interval, line, handle) {
    if (
      !window.location.pathname.includes("products") ||
      !window.location.pathname.includes("scoop") ||
      !window.location.pathname.includes("litter-mat") ||
      !window.location.pathname.includes("gift-cards")
    ) {
      const data = {
        weight,
        interval,
        line,
      }
      localStorage.setItem("subProduct", JSON.stringify(data))
      window.location.href = `/products/${handle}`
    } else {
      productForm.showSelectedSubscription(weight, interval, line)
      window.location.href = `/products/${handle}`
    }
  }

  // Upsell management methods (now common to both)
async refreshUpsells() {
  // Get current cart data
  const cartData = await this.getItems()
  
  // Debug cart contents
  console.log('=== REFRESH UPSELLS DEBUG ===');
  console.log('Cart items:', cartData.items.map(item => ({
    handle: item.handle,
    product_type: item.product_type,
    title: item.product_title || item.title,
    variant_id: item.variant_id
  })));
  
  // Get the upsell container
  const upsellContainer = document.querySelector('.upsell-carousel-container')
  if (!upsellContainer) {
    console.log('No upsell container found');
    return;
  }
  
  // Check if any qualifying products exist for banana
  const hasQualifyingProducts = cartData.items.some(item => {
    const isQualifying = item.product_type === 'Cat Litter' || 
                        item.handle.includes('scoop') || 
                        item.handle.includes('mat') || 
                        item.handle.includes('starter');
    
    if (isQualifying) {
      console.log('Found qualifying product:', item.handle, item.product_type);
    }
    return isQualifying;
  });
  
  // Check if banana is in cart
  const bananaInCart = cartData.items.some(item => {
    const isBanana = item.handle === 'yeoww-catnip-banana-toy';
    if (isBanana) {
      console.log('Banana found in cart');
    }
    return isBanana;
  });
  
  console.log('hasQualifyingProducts:', hasQualifyingProducts);
  console.log('bananaInCart:', bananaInCart);
  
  // Get all current upsell items
  const currentUpsells = document.querySelectorAll('.carousel-item')
  let hasVisibleUpsells = false
  
  console.log('Total upsell items found:', currentUpsells.length);
  
  // Check each upsell item visibility
  currentUpsells.forEach((item, index) => {
    const upsellCart = item.querySelector('.upsellCart')
    if (!upsellCart) {
      console.log(`Item ${index}: No upsellCart found`);
      return;
    }
    
    const classes = upsellCart.className
    let shouldShow = true
    
    console.log(`Item ${index}: Classes = ${classes}`);
    
    // Check if this upsell product is already in cart
    cartData.items.forEach(cartItem => {
      if (classes.includes(`upsellCart--${cartItem.variant_id}`)) {
        shouldShow = false;
        console.log(`Item ${index}: Found in cart, hiding (variant ${cartItem.variant_id})`);
      }
    });
    
    // Special validation for banana product (check for the scoop variant ID which seems to be the banana)
    if (classes.includes('upsellCart--45375002280085') || classes.includes('upsellCart--5')) {
      console.log(`Item ${index}: Processing banana product`);
      
      // Show banana if not in cart
      if (!bananaInCart) {
        shouldShow = true;
        
        // Update button state for banana
        const addButton = item.querySelector('.add2Cart');
        if (addButton) {
          if (hasQualifyingProducts) {
            // Enable button
            addButton.classList.remove('disabled');
            addButton.style.opacity = '1';
            addButton.style.pointerEvents = 'auto';
            addButton.style.cursor = 'pointer';
            
            // Restore original content
            this.restoreButtonContent(addButton);
            
            // Restore original onclick - get the actual banana variant ID
            const variantMatches = classes.match(/upsellCart--(\d+)/g);
            if (variantMatches && variantMatches.length > 0) {
              // Get the last variant ID which should be the actual product variant
              const lastMatch = variantMatches[variantMatches.length - 1];
              const variantId = lastMatch.replace('upsellCart--', '');
              addButton.setAttribute('onclick', `modalCart.addUpsell(${variantId})`);
              console.log(`Item ${index}: Banana enabled with variant ${variantId}`);
            }
          } else {
            // Disable button
            addButton.classList.add('disabled');
            addButton.style.opacity = '0.6';
            addButton.style.pointerEvents = 'none';
            addButton.style.cursor = 'not-allowed';
            addButton.removeAttribute('onclick');
            
            // Update button text
            const addText = addButton.querySelector('.addText');
            if (addText) {
              addText.innerHTML = 'Add litter, scoop, mat, or starter pack first';
              addText.style.fontSize = '11px';
              addText.style.lineHeight = '1.2';
            }
            
            console.log(`Item ${index}: Banana disabled - no qualifying products`);
          }
        }
      } else {
        shouldShow = false;
        console.log(`Item ${index}: Banana hidden - already in cart`);
      }
    }
    
    if (shouldShow) {
      item.style.display = 'block';
      hasVisibleUpsells = true;
      console.log(`Item ${index}: Showing`);
    } else {
      item.style.display = 'none';
      console.log(`Item ${index}: Hiding`);
    }
  });
  
  console.log('hasVisibleUpsells:', hasVisibleUpsells);
  
  // Hide entire upsell section if no visible upsells
  if (!hasVisibleUpsells) {
    upsellContainer.style.display = 'none';
    console.log('Hiding entire upsell container');
  } else {
    upsellContainer.style.display = 'block';
    console.log('Showing upsell container');
    // Reset carousel to first item
    this.resetCarousel();
  }
  
  console.log('=== END REFRESH UPSELLS DEBUG ===');
}

  restoreButtonContent(button, variantId, originalPrice) {
      if (!button) return;
      
      const priceSpan = button.querySelector('.addprice');
      const textSpan = button.querySelector('.addText');
      
      if (priceSpan) {
        priceSpan.style.display = 'inline';
        if (originalPrice) {
          priceSpan.textContent = originalPrice;
        }
      }
      
      if (textSpan) {
        textSpan.innerHTML = 'Add to cart';
        textSpan.style.fontSize = '';
        textSpan.style.lineHeight = '';
      }
    }



  resetCarousel() {
    const carouselTrack = document.getElementById('upsell-carousel-track')
    if (!carouselTrack) return
    
    const visibleItems = Array.from(carouselTrack.querySelectorAll('.carousel-item')).filter(
      item => item.style.display !== 'none'
    )
    
    if (visibleItems.length > 0) {
      carouselTrack.style.transform = 'translateX(0%)'
      
      // Update button states
      const prevBtn = document.querySelector('.carousel-prev')
      const nextBtn = document.querySelector('.carousel-next')
      
      if (prevBtn) prevBtn.disabled = true
      if (nextBtn) nextBtn.disabled = visibleItems.length <= 1
    }
  }

  addUpsell(variantId, quantity) {
    console.log("111")
    if (variantId || quantity) {
      let count = 1
      console.log(quantity)
      if (quantity) {
        count = quantity
      }
      const formData = {
        items: [
          {
            id: variantId,
            quantity: count,
          },
        ],
      }

      this.addItem(formData).then((res) => {
        this.updateCart()
        // Remove the specific upsell item that was just added
        const upsellElement = document.querySelector(`.upsellCart--${variantId}`)?.closest('.carousel-item')
        if (upsellElement) {
          upsellElement.style.display = 'none'
        }
      })
    }
  }

  // Method only for non-star version
  addUpsellBag(variantId, sellingPlan) {
    if (!this.starEnabled && variantId) {
      let count = 1
      console.log('sellingPlan = '+sellingPlan);
      const formData = {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlan,
        properties: {
          _interval: 2,
        },
      }

      this.addItem(formData).then((res) => this.updateCart())
    }
  }

  // Version-specific render methods
  renderCartItems(cart) {
    console.log('renderCartItems called, starEnabled:', this.starEnabled);
    if (this.starEnabled) {
      this.renderCartItemsStar(cart)
    } else {
      this.renderCartItemsRegular(cart)
    }
  }

  renderCartItemsStar(cart) {
    const cartSubTotal = document.querySelector(".subtotal__price")
    cartSubTotal.innerHTML = this.formatter.format(cart.total_price / 100)

    const numberOfItemsInTheCartContainer = document.getElementById("number-of-items-of-the-cart")
    numberOfItemsInTheCartContainer.textContent = cart.item_count + `${cart.item_count === 1 ? " item" : " items"}`

    const headerCartCount = document.getElementById("header-cart-count")
    headerCartCount.textContent = cart.item_count

    const ajaxCartFooterMessage = document.querySelector(".footer__free-shipping-message")
    const discCnt = document.querySelector(".disc-cnt")

    if (cart.total_price == 2317) {
      ajaxCartFooterMessage.style.display = "flex"
      ajaxCartFooterMessage.innerHTML = `<img src="//catalystpet.com/cdn/shop/t/306/assets/cart-icon.svg?v=117125376054619729981779214436" alt="Shopping cart" />
          Add products to get <strong>Free Shipping!</strong>
          `
    } else {
      ajaxCartFooterMessage.style.display = "flex"
      ajaxCartFooterMessage.innerHTML = `
          <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-icon.svg?v=117125376054619729981779214436" alt="Shopping cart" />
          You're qualified for <strong>Free Shipping!</strong>
          `
    }

    // Manage zero_items class based on cart state
    const cartWrapper = document.querySelector(".ajax-cart__wrapper")
    if (cart.total_price == 0) {
      cartWrapper.classList.add("zero_items")
      ajaxCartFooterMessage.style.display = "block"
      const a = document.createElement("a")
      a.href = "/products/cat-litter-healthy-cat-formula"
      a.innerHTML = `<img src="//catalystpet.com/cdn/shop/t/306/assets/cart-icon.svg?v=117125376054619729981779214436" alt="Shopping cart" />
          Add products to get <strong>Free Shipping!</strong>
          `
      a.style.color = "#000"
      ajaxCartFooterMessage.textContent = ""
      ajaxCartFooterMessage.append(a)
    } else {
      cartWrapper.classList.remove("zero_items")
    }

    const fragment = document.createDocumentFragment()

    let totalSubscriptionPrice = 0
    cart.items.forEach((product, index) => {
      const isSubscription = Boolean(product.properties?._interval)
      const variantId = product.variant_id

      const div = document.createElement("div")
      div.classList.add("ajax-cart__product")
      if (isSubscription) {
        const price = product.price / 100
        totalSubscriptionPrice += price
      }

      let template = `
              <div class="product__image-wrapper">
                  <img class="product__image" src="${product.featured_image.url?.replace(".png", "_240x.png").replace(".jpg", "_240x.jpg")}" alt="" />
              </div>
          `

      if (product.product_type == "Cat Litter" && !isSubscription) {
        template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Purchase One Time</span>
                          <h5>${product.product_title}</h5>
                          
                          <div class="product__variant-changer">
                          <button data-action="decrease" onclick="modalCart.changeWeight('decrease', '${product.variant_title}', ${Number(index) + 1}, '${product.handle}')">
                          <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-minus.svg?v=39928156426193562841779214435" alt="" />
                              </button>
                              <input value="${parseInt(product.variant_title)}lbs" type="text" disabled />
                              <button onclick="modalCart.changeWeight('increase', '${product.variant_title}', ${Number(index) + 1}, '${product.handle}')">
                              <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-plus.svg?v=82162463509222014651779214436" alt="" />
                              </button>
                            
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
      }

      if (product.product_type == "Cat Litter" && isSubscription) {
        const discount = document.querySelector(".ajax-cart-discount")
        const discountText = document.querySelector("#ajax-cart__header-discount")
        div.classList.add("ajax-cart__product--subscription")
        discount.style.display = "block"
        discountText.style.display = "none"
        template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Subscription</span>
                          <h5>${product.product_title.replace(" 5.00% Off Auto renew", "")}</h5>

                          <div class="product__prices">
                            <span class="product__prices__variant">${parseInt(product.variant_title)}lb</span>
                            <div class="actions__edit" onclick="modalCart.editSubscription('${product.variant_title}', '${product.properties._interval}', '${Number(index) + 1}', '${product.handle}')">
                                <img src="//catalystpet.com/cdn/shop/t/306/assets/edit-icon-green.svg?v=145034801622607232141779214436" alt="" />
                                
                            </div>
                         
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>
                          <span class="actions__price">${this.formatter.format(product.price / 100)}</span>

                          <span class="actions__interval">${this.showInterval(product.properties._interval)}</span>

                      </div>
                  </div>
              `
      }

      if (product.product_type != "Cat Litter") {
        if (product.product_title == "Catalyst Starter Pack") {
          const removeDiskount = document.querySelector(".remove-diskount")
          removeDiskount.setAttribute("data-line", Number(index) + 1)
          template += `
                  <div class="product__details-wrapper product__details-wrapper--str ">
                      <div class="product__details">
                          <span>Purchase One Time</span>
                          <h5 class="${Number(index) + 1}">${product.product_title}</h5>
                          <p class="product__in">price with discount - $22.8</p>
                          <div class="product__variant-changer" style="border: none;">
                          
                          </div>
                      </div>

                      <div class="product__actions">
                          
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
        } else {
          template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Purchase One Time</span>
                          <h5 class="${Number(index) + 1}">${product.product_title}</h5>
                          
                          <div class="product__variant-changer">
                          <button
                          data-action="decrease"
                          data-line="${index}"
                          data-qty="${product.quantity}"
                          onclick="modalCart.changeQty(this)"
                      >
                      <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-minus.svg?v=39928156426193562841779214435" alt="" />
                      </button>
                      <input value="${product.quantity}" type="text" disabled />
                      <button
                          data-action="increase"
                          data-line="${index}"
                          data-qty="${product.quantity}"
                          onclick="modalCart.changeQty(this)"
                      >
                      <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-plus.svg?v=82162463509222014651779214436" alt="" />
                      </button>
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
        }
      }

      div.innerHTML = template
      fragment.append(div)
    })

    // Star-specific discount logic
    let result = totalSubscriptionPrice / 3.333
    result = Math.round(result * 10) / 10

    const allFalse = cart.items.every((product, index) => {
      const isSubscription = Boolean(product.properties?._interval)
      return !isSubscription
    })
    let btnStar = document.querySelector(".ajax-cart-discount__btn--star")
    let btnRev = document.querySelector(".ajax-cart-discount__btn--rev")
    const footerCta = document.querySelector(".footer__cta")
    const removeDiscount = document.querySelector(".remove-diskount")

    if (allFalse) {
      localStorage.removeItem("discountHref")
      if (btnStar) btnStar.style.display = "none"
      if (btnRev) btnRev.style.display = "none"
      const headerDiscount = document.querySelector("#ajax-cart__header-discount")
      if (headerDiscount) headerDiscount.style.display = "block"
      
      var element = document.querySelector(".remove-diskount")
      if (element && element.hasAttribute("data-line")) {
        var lineValue = element.getAttribute("data-line")
        element.removeAttribute("data-line")
        this.deleteItem(lineValue).then((res) => this.updateCart())
      }
      if (removeDiscount) removeDiscount.style.display = "none"
    } else {
      if (footerCta) footerCta.setAttribute("href", "/checkout/?&discount=x")
      if (btnStar) {
        btnStar.style.display = "block"
        btnStar.classList.remove("ajax-cart-discount__btn--non2")
      }
      if (btnRev) btnRev.style.display = "block"
      const separator = document.querySelector(".ajax-cart-discount__separ")
      if (separator) separator.style.display = "block"
      if (removeDiscount) removeDiscount.style.display = "none"
      
      if (btnRev && result) {
        btnRev.querySelector(".ajax-cart-discount__text").innerHTML = `<div class="ajax-cart-discount-text-inf"> <p>30% OFF</p> <div class="ajax-cart-discount__inf"> off your <strong>litter</strong> worth <div class="disc-cnt">$${result}</div> </div> </div>
        
        <span>
          cat30
          <img src="//catalystpet.com/cdn/shop/t/306/assets/copy-icon.svg?v=69098265902013982531779214433" alt="Copy" />
        </span>`
      } else if (btnRev) {
        btnRev.querySelector(".ajax-cart-discount__text").innerHTML = `<div class="ajax-cart-discount-text-inf"><p>30% OFF</p>
        <div class="ajax-cart-discount__inf">off your <strong>worth</strong></strong><br><div class="disc-cnt" style="display:none;"></div></div></div>
      
        <span>
          cat30
          <img src="//catalystpet.com/cdn/shop/t/306/assets/copy-icon.svg?v=69098265902013982531779214433" alt="Copy" />
        </span>`
      }

      if (btnStar) {
        btnStar.querySelector(".ajax-cart-discount__text").innerHTML = `<div class="ajax-cart-discount-text-inf"><p>60% OFF</p>
        <div class="ajax-cart-discount__inf">off a <strong>scoop & mat</strong></strong><br>worth <div class="shadow">$34.2</div></div></div></div>

        <span>
          starterpack
          <img src="//catalystpet.com/cdn/shop/t/306/assets/copy-icon.svg?v=69098265902013982531779214433" alt="Copy" />
        </span>`
      }
    }

    console.log('Discount debug:', {
      totalSubscriptionPrice,
      result,
      allFalse,
      btnRevExists: !!btnRev,
      footerCtaExists: !!footerCta
    });

    const cartProductsContainer = document.querySelector(".ajax-cart__products")
    cartProductsContainer.innerHTML = ""
    cartProductsContainer.prepend(fragment)
  }

  renderCartItemsRegular(cart) {
    console.log(cart);
    var hasCatLitter = cart.items.some(item => item.product_type === "Cat Litter" && !Boolean(item.properties?._interval)); //one time
    var hasBag = cart.items.some(item => item.product_type === "Accessories" && item.properties && !('_interval' in item.properties));

    var hasCatLitter2 = cart.items.some(item => item.product_type === "Cat Litter" && Boolean(item.properties?._interval));  //subscribe
    var onlyFourMonthSubscription = cart.items.every(item => item.product_type === "Cat Litter" && item.properties && item.properties._interval === 4); //subscribe for 4
    var hasBag2 = cart.items.some(item => item.product_type === "Accessories" && item.properties && '_interval' in item.properties);

    var additional = cart.items.some(item => item.product_type === "Additional");

    // Add a more generic check for waste bags
    var hasBioWasteBags = cart.items.some(item => 
      item.product_title.includes("Biodegradable Pet Waste Bags") || 
      item.product_title.includes("Waste Bags")
    );

    // UPDATED SECTION: Check for bags without cat litter (any kind of bag)
    if (!hasCatLitter && !hasCatLitter2 && !additional && hasBioWasteBags) {
      console.log("Removing waste bags because no cat litter is in cart");
      
      // Find and remove any waste bag products
      function getCartItemsByTitle(searchTitle) {
        return fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const items = cart.items.filter(item => 
              (item.product_title.includes("Biodegradable Pet Waste Bags") || 
               item.product_title.includes("Waste Bags"))
            );
            return items.map(item => item.key);
          })
          .catch(error => {
            console.error('Error fetching cart:', error);
            return [];
          });
      }
      
      function removeItemsFromCart(itemKeys) {
        if (!itemKeys || itemKeys.length === 0) return;
        
        // Create updates object for all items to remove
        const updates = {};
        itemKeys.forEach(key => {
          updates[key] = 0;
        });
        
        // Send one request to update all items
        fetch('/cart/update.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            updates: updates
          })
        })
        .then(response => response.json())
        .then(cart => {
          console.log('Updated cart after removing waste bags:', cart);
          this.updateCart();
        })
        .catch(error => console.error('Error removing items:', error));
      }
      
      // Call the functions to remove waste bags
      getCartItemsByTitle("Waste Bags").then(itemKeys => {
        removeItemsFromCart.call(this, itemKeys);
      });
    }

    if (!hasCatLitter2 && hasBag2) {
      function getCartItemIndexById(productId) {
        return fetch('/cart.js')
          .then(response => response.json())
          .then(cart => {
            const item = cart.items.find(item => item.id === productId && item.properties && '_interval' in item.properties );
            return item ? item.key : null; 
          })
          .catch(error => console.error('Error fetching cart:', error));
      }
      const removeItemFromCartByKey = (itemKey) => {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            id: itemKey,
            quantity: 0
          })
        })
        .then(response => response.json())
        .then(cart => {
          console.log('Updated cart2:', cart);
          hasBag = false;
          this.updateCart();
        })
        .catch(error => console.error('Error removing item:', error));
      };
      
      function removeItemFromCartById(productId) {
        getCartItemIndexById(productId).then(itemKey => {
          if (itemKey) {
            removeItemFromCartByKey(itemKey);
          } else {
            console.log('Product not found in cart 2');
          }
        });
      }
      removeItemFromCartById(45065132507285)  
    }

    if(!hasCatLitter2 && hasCatLitter) {
      if(document.querySelectorAll('.add2Cart--subscribe').length > 0){
        document.querySelector('.add2Cart--subscribe').style.display = 'none'
      }
    } else {
      console.log('SUBSUBSUB');
      console.log(cart.items);

      if(document.querySelectorAll('.add2Cart--subscribe').length > 0){
        document.querySelector('.add2Cart--subscribe').style.display = 'flex'
      }
      if(document.querySelector('.add2Cart--subscribe4') && document.querySelector('.add2Cart--subscribe2')) {
        if(cart.items.some(item => item.product_type === "Cat Litter" && item.properties && item.properties._interval === 4)) {
          document.querySelector('.add2Cart--subscribe4').style.display = 'flex'
          document.querySelector('.add2Cart--subscribe2').style.display = 'none'
          document.querySelector('.t120').style.display = 'inline'
          document.querySelector('.t60').style.display = 'none'
        } else {
          document.querySelector('.add2Cart--subscribe2').style.display = 'flex'
          document.querySelector('.add2Cart--subscribe4').style.display = 'none'
          document.querySelector('.t60').style.display = 'inline'
          document.querySelector('.t120').style.display = 'none'
          function getCartItemIndexById(productId) {
            return fetch('/cart.js')
              .then(response => response.json())
              .then(cart => {
                const item = cart.items.find(item => item.id === productId && item.properties && '_interval' in item.properties );
                return item ? item.key : null; 
              })
              .catch(error => console.error('Error fetching cart:', error));
          }
          const removeItemFromCartByKey = (itemKey) => {
            fetch('/cart/change.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                id: itemKey,
                quantity: 0
              })
            })
            .then(response => response.json())
            .then(cart => {
              console.log('Updated cart2:', cart);
              hasBag = false;
              this.updateCart();
            })
            .catch(error => console.error('Error removing item:', error));
          };
          
          function removeItemFromCartById(productId) {
            getCartItemIndexById(productId).then(itemKey => {
              if (itemKey) {
                removeItemFromCartByKey(itemKey);
              } else {
                console.log('Product not found in cart 3');
              }
            });
          }
          removeItemFromCartById(45065132540053)
        }
      }
      if (document.querySelector('#bag-add-to-cart-sub4') && document.querySelector('#bag-add-to-cart-sub')) {
        if(onlyFourMonthSubscription) {
          document.querySelector('#bag-add-to-cart-sub4').style.display = 'flex'
          document.querySelector('#bag-add-to-cart-sub').style.display = 'none'
        } else {
          document.querySelector('#bag-add-to-cart-sub4').style.display = 'none'
          document.querySelector('#bag-add-to-cart-sub').style.display = 'flex'
        }
      }
    }

    if (!hasCatLitter  && !hasCatLitter2 && !additional) {
      if (document.querySelector('#bag-add-to-cart-sub4') && document.querySelector('#bag-add-to-cart-sub')) {
          document.querySelector('#bag-add-to-cart-sub4').style.display = 'none'
          document.querySelector('#bag-add-to-cart-sub').style.display = 'flex'
      }
    }

    const cartSubTotal = document.querySelector(".subtotal__price")
    cartSubTotal.innerHTML = this.formatter.format(cart.total_price / 100)

    const numberOfItemsInTheCartContainer = document.getElementById("number-of-items-of-the-cart")
    numberOfItemsInTheCartContainer.textContent = cart.item_count + `${cart.item_count === 1 ? " item" : " items"}`

    if(cart.item_count < 2) {
      document.querySelector('.ajax-cart').classList.add('ajax-cart--less')
    } else {
      document.querySelector('.ajax-cart').classList.remove('ajax-cart--less')
    }

    const headerCartCount = document.getElementById("header-cart-count")
    headerCartCount.textContent = cart.item_count

    const ajaxCartFooterMessage = document.querySelector(".footer__free-shipping-message")

    if (cart.total_price == 2317) {
      ajaxCartFooterMessage.style.display = "flex"
      ajaxCartFooterMessage.innerHTML = `
          <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-icon.svg?v=117125376054619729981779214436" alt="Shopping cart" />
          Add products to get <strong>Free Shipping!</strong>
          `
    } else {
      ajaxCartFooterMessage.style.display = "flex"
      ajaxCartFooterMessage.innerHTML = `<img src="//catalystpet.com/cdn/shop/t/306/assets/cart-icon.svg?v=117125376054619729981779214436" alt="Shopping cart" />
          You're qualified for <strong>Free Shipping!</strong>
          `
    }

    if (cart.total_price == 0) {
      ajaxCartFooterMessage.style.display = "block"
      const a = document.createElement("a")
      document.querySelector(".ajax-cart__wrapper").classList.add("zero_items")
      a.href = "/products/cat-litter-healthy-cat-formula"
      a.innerHTML = `<img src="//catalystpet.com/cdn/shop/t/306/assets/cart-icon.svg?v=117125376054619729981779214436" alt="Shopping cart" />
          Add products to get <strong>Free Shipping!</strong>
          `
      a.style.color = "#000"
      ajaxCartFooterMessage.textContent = ""
      ajaxCartFooterMessage.append(a)
    }

    const fragment = document.createDocumentFragment()

    let totalSubscriptionPrice = 0
    cart.items.forEach((product, index) => {
      const isSubscription = Boolean(product.properties?._interval)
      const isSubscription2 =  product.properties && '_interval' in product.properties
      const variantId = product.variant_id
      const div = document.createElement("div")
      div.classList.add("ajax-cart__product")
      if (isSubscription) {
        const price = product.price / 100
        totalSubscriptionPrice += price
      }

      let template = `
              <div class="product__image-wrapper">
                  <img class="product__image" src="${product.featured_image.url?.replace(".png", "_240x.png").replace(".jpg", "_240x.jpg")}" alt="" />
              </div>
          `

      if (product.product_type == "Cat Litter" && !isSubscription) {
        template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Purchase One Time</span>
                          <h5>${product.product_title}</h5>
                          
                          <div class="product__variant-changer">
                          <button data-action="decrease" onclick="modalCart.changeWeight('decrease', '${product.variant_title}', ${Number(index) + 1}, '${product.handle}')">
                          <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-minus.svg?v=39928156426193562841779214435" alt="" />
                              </button>
                              <input value="${parseInt(product.variant_title)}lbs" type="text" disabled />
                              <button onclick="modalCart.changeWeight('increase', '${product.variant_title}', ${Number(index) + 1}, '${product.handle}')">
                              <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-plus.svg?v=82162463509222014651779214436" alt="" />
                              </button>
                            
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
      }

      if (product.product_type == "Cat Litter" && isSubscription) {
        const discount = document.querySelector(".ajax-cart-discount")
        const discountText = document.querySelector("#ajax-cart__header-discount")
        div.classList.add("ajax-cart__product--subscription")
        discount.style.display = "block"
        discountText.style.display = "none"
        template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Subscription</span>
                          <h5>${product.product_title.replace(" 5.00% Off Auto renew", "")}</h5>

                          <div class="product__prices">
                            <span class="product__prices__variant">${parseInt(product.variant_title)}lb</span>
                            <div class="actions__edit" onclick="modalCart.editSubscription('${product.variant_title}', '${product.properties._interval}', '${Number(index) + 1}', '${product.handle}')">
                                <img src="//catalystpet.com/cdn/shop/t/306/assets/edit-icon-green.svg?v=145034801622607232141779214436" alt="" />
                                
                            </div>
                         
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>  
                          <span class="actions__price">${this.formatter.format(product.price / 100)}</span>
                          <span class="actions__interval">${this.showInterval(product.properties._interval)}</span>

                      </div>
                  </div>
              `
      }

      if (product.product_type == "Small Animal Bedding" && !isSubscription) {
        template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Purchase One Time</span>
                          <h5>${product.product_title}</h5>
                          
                          <div class="product__variant-changer">
                          <a href="${product.url}" class="actions__edit" )">
                                <img src="//catalystpet.com/cdn/shop/t/306/assets/edit-icon-green.svg?v=145034801622607232141779214436" alt="" />
                                
                            </a>
                            
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>  
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
      }
      if (product.product_type == "Small Animal Bedding" && isSubscription) {
        const discount = document.querySelector(".ajax-cart-discount")
        const discountText = document.querySelector("#ajax-cart__header-discount")
        div.classList.add("ajax-cart__product--subscription")
        discount.style.display = "block"
        discountText.style.display = "none"
        template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">
                          <span>Subscription</span>
                          <h5>${product.product_title.replace(" 5.00% Off Auto renew", "")}</h5>

                          <div class="product__prices">
                            <span class="product__prices__variant">${product.variant_title}</span>
                            <a href="${product.url}" class="actions__edit" )">
                                <img src="//catalystpet.com/cdn/shop/t/306/assets/edit-icon-green.svg?v=145034801622607232141779214436" alt="" />
                                
                            </a>
                         
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>  
                          <span class="actions__price">${this.formatter.format(product.price / 100)}</span>
                          <span class="actions__interval">${this.showInterval(product.properties._interval)}</span>

                      </div>
                  </div>
              `
      }
      
      if (product.product_type != "Cat Litter" && product.product_type != "Small Animal Bedding" ) {
        if (product.product_title == "Catalyst Starter Pack") {
          template += `
                  <div class="product__details-wrapper product__details-wrapper--str ww ${product.id}">
                      <div class="product__details">
                          <span>Purchase One Time</span>
                          <h5 class="${Number(index) + 1}">${product.product_title}</h5>
                         
                          <div class="product__variant-changer" style="border: none;">
                          
                          </div>
                      </div>

                      <div class="product__actions">
                      <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                      <span>Remove</span>
                      <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                    </div>
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
        } else if(product.product_type == 'Accessories' && isSubscription2) {
          template += `
          <div class="product__details-wrapper">
              <div class="product__details">

                  <span>Subscription</span>
                  <h5 class="${Number(index) + 1}">${product.product_title}</h5>
                  <span class="product__variant-type" style="font-family: Futura; font-size: 14px; font-style: normal; font-weight: 500; color: #027747;display: block;">
                    ${product.variant_title}
                  </span>
                  
                  <div class="product__variant-changer">
                  <button
                  data-action="decrease"
                  data-line="${index}"
                  data-qty="${product.quantity}"
                  onclick="modalCart.changeQty(this)"
              >
              <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-minus.svg?v=39928156426193562841779214435" alt="" />
              </button>
              <input value="${product.quantity}" type="text" disabled />
              <button
                  data-action="increase"
                  data-line="${index}"
                  data-qty="${product.quantity}"
                  onclick="modalCart.changeQty(this)"
              >
              <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-plus.svg?v=82162463509222014651779214436" alt="" />
              </button>
                  </div>
              </div>

              <div class="product__actions">
                <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                  <span>Remove</span>
                <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                </div>       
                  <div class="actions__price" style="margin-top: auto; text-align: right;">
                      ${this.formatter.format(product.price / 100)}
                  </div>
                  <span class="actions__interval" style="font-family: Futura; font-size: 10px; font-weight: 500; line-height: 1.9; color: #245134;">${this.showInterval(product.properties._interval)}</span>
              </div>
          </div>
      `
        } else {
          template += `
                  <div class="product__details-wrapper">
                      <div class="product__details">

                          <span>Purchase One Time</span>
                          <h5 class="${Number(index) + 1}">${product.product_title}</h5>

                          ${product.variant_title ? `
                            <span class="product__variant-type" style="font-family: Futura; font-size: 14px; font-style: normal; font-weight: 500; color: #027747;display: block;">
                              ${product.variant_title}
                            </span>
                          ` : ''}
                          
                          <div class="product__variant-changer">
                          <button
                          data-action="decrease"
                          data-line="${index}"
                          data-qty="${product.quantity}"
                          onclick="modalCart.changeQty(this)"
                      >
                      <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-minus.svg?v=39928156426193562841779214435" alt="" />
                      </button>
                      <input value="${product.quantity}" type="text" disabled />
                      <button
                          data-action="increase"
                          data-line="${index}"
                          data-qty="${product.quantity}"
                          onclick="modalCart.changeQty(this)"
                      >
                      <img src="//catalystpet.com/cdn/shop/t/306/assets/cart-plus.svg?v=82162463509222014651779214436" alt="" />
                      </button>
                          </div>
                      </div>

                      <div class="product__actions">
                        <div class="actions__remove" onclick="modalCart.deleteItemUpsell(${Number(index) + 1}, ${product.id})">
                          <span>Remove</span>
                          <img class=""  src="//catalystpet.com/cdn/shop/t/306/assets/cart_trash.svg?v=66666628054296528121779214436" alt="" />
                        </div>       
                          <div class="actions__price">
                              ${this.formatter.format(product.price / 100)}
                          </div>
                      </div>
                  </div>
              `
        }
      }

      div.innerHTML = template
      fragment.append(div)
    })

    let result = totalSubscriptionPrice / 3.333
    result = Math.round(result * 10) / 10

    const allFalse = cart.items.every((product, index) => {
      const isSubscription = Boolean(product.properties?._interval)
      return !isSubscription
    })
    
    // Small Animal Bedding in cart
    const onlySmallAnimalBedding = cart.items.every((product) => {
      return product.product_type === "Small Animal Bedding";
    });
  
    if (onlySmallAnimalBedding) { 
        const discountEl = document.querySelector('.ajax-cart-discount')
        const upsellEl = document.querySelector('.upsellCarts')
        if (discountEl) discountEl.style.display = 'none'
        if (upsellEl) upsellEl.style.display = 'none'
    } else {
        const discountEl = document.querySelector('.ajax-cart-discount')
        const upsellEl = document.querySelector('.upsellCarts')
        if (discountEl) discountEl.style.display = 'block'
        if (upsellEl) upsellEl.style.display = 'block'
    }
    
    let btnRev = document.querySelector(".ajax-cart-discount__btn--rev")
    const footerCta = document.querySelector(".footer__cta")

    if (allFalse) {
      localStorage.removeItem("discountHref")
      if (btnRev) btnRev.style.display = "none"
      const headerDiscount = document.querySelector("#ajax-cart__header-discount")
      if (headerDiscount) headerDiscount.style.display = "block"
    } else {
      if (footerCta) footerCta.setAttribute("href", "/checkout/?&discount=x")
      if (btnRev) {
        btnRev.style.display = "block"
        if (result) {
          btnRev.querySelector(".ajax-cart-discount__text").innerHTML = `<div class="ajax-cart-discount-text-inf"><p>30% OFF</p>
          <div class="ajax-cart-discount__inf">off your <strong>litter</strong> worth <div class="disc-cnt">$${result}</div></div>
          </div>
          <span>
            <img src="//catalystpet.com/cdn/shop/t/306/assets/copy-icon.svg?v=69098265902013982531779214433" alt="Copy" />
            CAT30  
          </span>
          `
        } else {
          btnRev.querySelector(".ajax-cart-discount__text").innerHTML = `<div class="ajax-cart-discount-text-inf"><p>30% OFF</p>
          <div class="ajax-cart-discount__inf">off your <strong>worth</strong></strong> <div class="disc-cnt" style="display:none;"></div></div></div>
        
          <span>
          CAT30
            
          </span>
          `
        }
      }
    }

    console.log('Discount debug:', {
      totalSubscriptionPrice,
      result,
      allFalse,
      btnRevExists: !!btnRev,
      footerCtaExists: !!footerCta
    });

    const cartProductsContainer = document.querySelector(".ajax-cart__products")
    cartProductsContainer.innerHTML = ""
    cartProductsContainer.prepend(fragment)
  }

  // Common methods for both versions
  async updateCart() {
    const cartData = await this.getItems()
    await this.renderCartItems(cartData)
    await this.refreshUpsells()
  }

  deleteItem(line) {
    this.changeItem({ line: line, quantity: 0 }).then((res) => {
      this.renderCartItems(res)
    })
  }

  deleteItem2(line) {
    this.changeItem({ id: line, quantity: 0 }).then((res) => {
      this.renderCartItems(res)
    })
  }

  deleteItemUpsell(line, id) {
    this.changeItem({ line: line, quantity: 0 }).then((res) => {
      this.renderCartItems(res)
      // Show the upsell item that was just removed
      const upsellElement = document.querySelector(`.upsellCart--${id}`)
      if (upsellElement) {
        upsellElement.closest('.carousel-item').style.display = 'block'
      }
      // Make sure carousel container is visible if we have visible upsells
      this.refreshUpsells()
    })
  }

  overlayLoading(switchOn = true) {
    if (switchOn) {
      const loadingDiv = document.createElement('div');
      loadingDiv.classList.add('loading-cart');
      loadingDiv.textContent = 'Loading';
      
      document.body.append(loadingDiv);
      } else {
      const loadingDiv = document.querySelector('.loading-cart');
      if (loadingDiv) {
      loadingDiv.remove();
      }
    }
  }

  async toggleCart() {
    const cartWrapper = document.querySelector(".ajax-cart__wrapper")

    await this.updateCart()
    
    // Manage zero_items class based on current cart state
    const cartData = await this.getItems()
    if (cartData.total_price == 0) {
      cartWrapper.classList.add("zero_items")
    } else {
      cartWrapper.classList.remove("zero_items")
    }
    
    cartWrapper.classList.toggle("open")
    if (cartWrapper.classList.contains("open")) {
      const offsetY = window.pageYOffset
    } else {
      document.body.classList.remove("vh")
    }
    if (window.matchMedia("(min-width: 601px)").matches) {
      if (cartWrapper.classList.contains("open")) {
        document.body.setAttribute("style", "overflow: hidden")
      } else {
        document.body.removeAttribute("style")
      }
    }
  }

  // Discount methods (conditional based on starEnabled)
  addDiscount() {
    const discountBtn2 = document.querySelector(".ajax-cart-discount__btn--rev")
    const footerCta = document.querySelector(".footer__cta")
    const discountText = discountBtn2.querySelector(".ajax-cart-discount__text")

    const discountCode = "cat30"
    const currentHref = footerCta.getAttribute("href")
    const newHref = currentHref + "?&discount=" + discountCode

    if (this.starEnabled) {
      const discountBtn = document.querySelector(".ajax-cart-discount__btn--star")
      const separ = document.querySelector(".ajax-cart-discount__separ")
      const removeDiscount = document.querySelector(".remove-diskount")
      
      discountBtn.style.display = "none"
      separ.style.display = "none"
      removeDiscount.style.display = "block"

      if (removeDiscount.hasAttribute("data-line")) {
        removeDiscount.removeAttribute("data-line")
      }
    }

    localStorage.setItem("discountHref", newHref)
    footerCta.setAttribute("href", "")
    footerCta.setAttribute("href", newHref)
    discountText.textContent = "Your discount is applied!"
  }

  addDiscount2() {
    if (!this.starEnabled) return; // Only for star-enabled version
    
    const discountBtn = document.querySelector(".ajax-cart-discount__btn--rev")
    const discountBtn2 = document.querySelector(".ajax-cart-discount__btn--star")
    const separ = document.querySelector(".ajax-cart-discount__separ")
    const removeDiscount = document.querySelector(".remove-diskount")
    const footerCta = document.querySelector(".footer__cta")
    const discountCode = "starterpack"

    const currentHref = footerCta.getAttribute("href")
    const newHref = currentHref + "?&discount=" + discountCode
    localStorage.setItem("discountHref", newHref)

    discountBtn.style.display = "none"
    document.querySelector(".upsellCarts").style.display = "none"
    removeDiscount.style.display = "block"
    discountBtn2.classList.add("ajax-cart-discount__btn--non2")

    const starterPackId = this.starEnabled ? 43642840023189 : 7983432532117
    const formData = {
      items: [
        {
          id: starterPackId,
          quantity: 1,
        },
      ],
    }
    footerCta.setAttribute("href", newHref)
    this.addItem(formData).then((res) => this.updateCart())
  }

  removeDiscount() {
    const footerCta = document.querySelector(".footer__cta")
    localStorage.removeItem("discountHref")
    
    if (this.starEnabled) {
      const discountBtn2 = document.querySelector(".ajax-cart-discount__btn--star")
      const separ = document.querySelector(".ajax-cart-discount__separ")
      
      separ.style.display = "block"
      document.querySelector(".upsellCarts").style.display = "block"
      discountBtn2.classList.remove("ajax-cart-discount__btn--non2")
    }
    
    var element = document.querySelector(".remove-diskount")
    if (element && element.hasAttribute("data-line")) {
      var lineValue = element.getAttribute("data-line")
      this.deleteItem(lineValue).then((res) => this.updateCart())
    } else {
      this.updateCart()
    }

    footerCta.setAttribute("href", "/checkout?&discount=x")
  }
}


const modalCart = new Cart()